// extracted by mini-css-extract-plugin
module.exports = {"pageButtonSlider":"styles_pageButtonSlider__c73_e","pageButtonSliderDot":"styles_pageButtonSliderDot__TEnL_"};